import React from 'react';
import PropTypes from 'prop-types';
import ActivePokemon from '../ActivePokemon';
import BenchSlot from '../Bench/BenchSlot';
import Deck from '../Deck';
import DiscardPile from '../DiscardPile';
import PrizeSlot from '../Prizes/PrizeSlot';
import Anchor from '../Motion/Anchor';
import OpponentHand from './OpponentHand';
import TrainerInPlay from './TrainerInPlay';
import { anchors } from '../Motion/anchorNames';
import MatLayout from './MatLayout';

/** What's in one of a player's spots in the game: the cards themselves, marked for the animations (Anchor). */
const liveSpot = (userId) => (zone, position) => {
  switch (zone) {
    case 'prize':
      return <Anchor name={anchors.prize(userId, position)}><PrizeSlot userId={userId} position={position} /></Anchor>;
    case 'active':
      return <Anchor name={anchors.active(userId)}><ActivePokemon userId={userId} /></Anchor>;
    case 'bench':
      return <Anchor name={anchors.bench(userId, position)}><BenchSlot userId={userId} position={position} /></Anchor>;
    case 'deck':
      return <Anchor name={anchors.deck(userId)}><Deck userId={userId} /></Anchor>;
    case 'discard':
      return <Anchor name={anchors.discard(userId)}><DiscardPile userId={userId} /></Anchor>;
    case 'play':
      return <Anchor name={anchors.play(userId)}><TrainerInPlay userId={userId} /></Anchor>;
    default:
      return null;
  }
};

/** The game on the original playmat photo (MatLayout). */
const MatBoard = ({ playerId, opponentId, turned }) => (
  <MatLayout
    turned={turned}
    opponentSpot={liveSpot(opponentId)}
    playerSpot={liveSpot(playerId)}
    // The opponent's hand is held past the far edge, toward them: their draws and prizes fly there.
    opponentHand={<Anchor name={anchors.hand(opponentId)}><OpponentHand userId={opponentId} /></Anchor>}
  />
);

MatBoard.propTypes = {
  playerId: PropTypes.number.isRequired,
  opponentId: PropTypes.number.isRequired,
  turned: PropTypes.bool,
};

export default MatBoard;
